<template>
  <div
    class="panel-item">
    <h5 class="font-weight-light panel-header pl-3 py-2">Quản lý đơn hàng</h5>
    <div v-if="histories && histories.length > 0">
      <div
        v-for="item in histories"
        class="item">
        <router-link :to="`/order-histories/${item.id}?type=${item.type}`">
          <div class="title">{{ item.product_name }}</div>
          <div class="item-detail">Mã đơn hàng: {{ item.order_code }}</div>
          <div class="item-detail">Đặt hàng: {{ item.created_at }}</div>
          <div class="item-detail">Trạng thái: {{ item.state === 'OPEN' ? "Mới" : 'Đã thanh toán' }}</div>
        </router-link>
      </div>
    </div>

    <infinite-loading
      :identifier="infiniteId"
      @infinite="infiniteHandler">
      <div slot="spinner">Đang tìm kiếm...</div>
      <div slot="no-more">Không còn đơn hàng nào!</div>
      <div slot="no-results">Không có đơn hàng nào phù hợp</div>
    </infinite-loading>
  </div>
</template>

<script>
    import rf from "../../communicate/RequestFactory";
    import {errorToaster} from "../../services/ErrorHandler";
    import InfiniteLoading from "vue-infinite-loading";

    export default {
        name: "OrderHistory",
        components: {
            InfiniteLoading
        },
        data: function () {
            return {
                histories: [],
                limit: 10,
                page: 1,
                infiniteId: +new Date(),
            }
        },
        mounted() {
            this.infiniteId += 1;
        },
        methods: {
            infiniteHandler($state) {
                this.$Progress.start();
                const data = {
                    page: this.page,
                    limit: this.limit
                };
                rf.getRequest('OrderHistoryRequest').getOrderHistory(data).then((res) => {
                    if (res.status === 200 && res.data && res.data.length) {
                        this.page += 1;
                        this.histories.push(...res.data);
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                    if (res.status !== 200) {
                        errorToaster('Cố vấn Phong Thủy', res.message);
                    }
                    this.$Progress.finish();
                }).catch(err => {
                    errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối');
                    $state.complete();
                    this.$Progress.fail();
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
  .panel-item {
    width: 100%;
    padding-top: 16px;

    .item {
      width: 100%;
      background-color: white;
      padding: 10px;
      margin-bottom: 10px;

      .title {
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        color: black;
      }

      .item-detail {
        font-size: 12px;
        color: #626262;
        padding: 3px 0;
      }
    }
    .panel-header {
      color: #fff ;
      background: #4189EB;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/history/OrderHistory.vue